let baseAPI = process.env.VUE_APP_BASE_API

if (process.env.VUE_APP_TESTING) {
  baseAPI = localStorage.getItem('baseAPI') ?? process.env.VUE_APP_BASE_API
}

export default baseAPI
